export const preview = {
    state: {
        show: false,
        content: null
    },
    mutations: {
        TOGGLE_PREVIEW(state, { show, content }) {
            state.show = show
            state.content = content
        }
    },
    actions: {
        togglePreview({ commit }, { show, content }) {
            commit('TOGGLE_PREVIEW', { show, content })
        }
    },
    getters: {
        getPreviewShow: state => state.show,
        getPreviewContent: state => state.content
    }
}
